import { render, staticRenderFns } from "./ManageCityForm.vue?vue&type=template&id=0910d220&scoped=true"
import script from "./ManageCityForm.vue?vue&type=script&lang=js"
export * from "./ManageCityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0910d220",
  null
  
)

export default component.exports